// Libraries
import React from 'react';
import {NextSeo} from "next-seo";
import Head from "next/head";

// Components
import PrivacyPolicyUI from "../components/PrivacyPolicyUI";

// Constants
import {META_INFO} from "../constants/metaConstants";


export default function PrivacyPolicy() {
    return (
        <>
            <Head>
                <meta content={META_INFO.PRIVACY_POLICY_PAGE_TITLE} name="twitter:title"/>
                <meta content={META_INFO.PRIVACY_POLICY_PAGE_URL} name="twitter:url"/>
            </Head>

            <NextSeo
                title={META_INFO.PRIVACY_POLICY_PAGE_TITLE}
                canonical={META_INFO.PRIVACY_POLICY_PAGE_URL}
                openGraph={{
                    title: META_INFO.PRIVACY_POLICY_PAGE_TITLE,
                    url: META_INFO.PRIVACY_POLICY_PAGE_URL
                }}
            />

            <PrivacyPolicyUI />
        </>
    );
}
